import styled from "styled-components";
import { GREEN_TINT, GREEN_BORDER } from "../../constants/theme";

export const ModalWrap = styled.div`
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ModalBack = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
`;
export const ModalCard = styled.div`
  position: relative;
  width: 92vw;
  max-width: 720px;
  max-height: 85vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
`;
export const ModalBar = styled.div`
  position: sticky;
  top: 0;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  span.icon {
    display: inline-flex;
    padding: 8px;
    border-radius: 12px;
    background: ${GREEN_TINT};
    color: #24ae7c;
  }
  button {
    margin-left: auto;
    color: #64748b;
  }
  button:hover {
    color: #0f172a;
  }
`;
export const ModalBody = styled.div`
  padding: 16px 24px;
  font-size: 18px;
  line-height: 1.5;
  color: #475569;
`;
export const ModalList = styled.ul`
  padding: 0 24px 24px 40px;
  font-size: 14px;
  line-height: 1.5;
  list-style: none;
  margin: 0;
  li {
    display: flex;
    gap: 12px;
    color: #0f172a;
  }
  li + li {
    margin-top: 12px;
  }
  li::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: #24ae7c;
    margin-top: 8px;
  }
`;
